import { object, string, func } from 'prop-types'
import Div from '../layout/Div'
import Icon from './Icon'
import Image from './Image'

const ImageUploadedDropzone = ({
  cssFigureClass = '',
  cssImageClass = '',
  manageFileCallback = () => { },
  file
}) => {
  const deleteFile = () => {
    manageFileCallback({ file, action: 'remove' })
  }

  const setFirstFile = () => {
    manageFileCallback({ file, action: 'setFirst' })
  }

  return (
    <Div cssClass='imageDropzone'>
      <Image src={file} cssFigureClass={cssFigureClass} cssImageClass={cssImageClass} />
      <Icon icon='icon-cancel-circle' spanClass='deleteDroppedImage' callback={deleteFile} areaLabel='Delete uploaded image' />
      <Icon icon='icon-medal' spanClass='setFirstImage' callback={setFirstFile} areaLabel='Set first image' />
    </Div>
  )
}

ImageUploadedDropzone.propTypes = {
  cssFigureClass: string,
  cssImageClass: string,
  manageFileCallback: func,
  file: object
}

export default ImageUploadedDropzone
